// import React, { useState, useMemo } from "react";
// import {
//   Table,
//   Badge,
//   Button,
//   Spinner,
//   Alert,
//   Nav,
//   Modal,
//   Form,
//   Row,
//   Col,
//   ButtonGroup,
// } from "react-bootstrap";
// import { IoEye, IoCreate, IoTrash, IoDownload } from "react-icons/io5";
// import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
// import { MdAccessTime, MdCheckCircle } from "react-icons/md";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const OrdersTable = ({
//   orders = [],
//   loading = false,
//   error = null,
//   pagination = {},
//   meta = {},
//   currentSortField = null,
//   currentSortOrder = "DESC",
//   onSort = () => {},
//   onEdit = () => {},
//   onDelete = () => {},
//   onView = () => {},
//   // 🎯 BARU: fungsi async fetch semua data dari server
//   onFetchAllForExport = null,
// }) => {
//   const [activeTab, setActiveTab] = useState("all"); // 'all', 'SERVICE', 'APPOINTMENT'

//   // ─────────────────────────────────────────────────────────
//   // 🎯 Offset pagination (biar nomor tabel tidak reset antar halaman)
//   // ─────────────────────────────────────────────────────────
//   const currentPage = Number(
//     pagination?.page ?? pagination?.currentPage ?? meta?.page ?? 1,
//   );
//   const perPage = Number(
//     pagination?.limit ??
//       pagination?.perPage ??
//       meta?.perPage ??
//       meta?.limit ??
//       (orders.length || 10),
//   );
//   const rowOffset = (currentPage - 1) * perPage;

//   // ─────────────────────────────────────────────────────────
//   // State Export
//   // ─────────────────────────────────────────────────────────
//   const [showExportModal, setShowExportModal] = useState(false);
//   const [exportCategory, setExportCategory] = useState("ALL");
//   const [exportDateField, setExportDateField] = useState("appointment_date");
//   const [exportDateFrom, setExportDateFrom] = useState("");
//   const [exportDateTo, setExportDateTo] = useState("");
//   const [exportIncludeFuture, setExportIncludeFuture] = useState(true);
//   const [exportSource, setExportSource] = useState("current"); // 'current' | 'all'
//   const [selectedColumns, setSelectedColumns] = useState([]);
//   const [exporting, setExporting] = useState(false);
//   const [allDataCache, setAllDataCache] = useState(null);

//   // ─────────────────────────────────────────────────────────
//   // Counts per kategori
//   // (pakai allDataCache kalau ada, biar akurat total server)
//   // ─────────────────────────────────────────────────────────
//   const counts = useMemo(() => {
//     const source =
//       allDataCache && allDataCache.length > 0 ? allDataCache : orders;
//     return {
//       all: source.length,
//       SERVICE: source.filter((o) => o.category === "SERVICE").length,
//       APPOINTMENT: source.filter((o) => o.category === "APPOINTMENT").length,
//     };
//   }, [orders, allDataCache]);

//   const filteredOrders = useMemo(() => {
//     if (activeTab === "all") return orders;
//     return orders.filter((order) => order.category === activeTab);
//   }, [orders, activeTab]);

//   // ─────────────────────────────────────────────────────────
//   // Format helpers
//   // ─────────────────────────────────────────────────────────
//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("id-ID", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const formatDateTime = (dateString) => {
//     if (!dateString) return "-";
//     const date = new Date(dateString);
//     return date.toLocaleString("id-ID", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // ─────────────────────────────────────────────────────────
//   // Badge renderers
//   // ─────────────────────────────────────────────────────────
//   const getPaymentStatusBadge = (status) => {
//     if (status === "PAYMENT SUCCESS" || status === "PAID")
//       return <Badge bg="success">Success</Badge>;
//     if (status === "NEED PAYMENT")
//       return (
//         <Badge bg="warning" text="dark">
//           Need Payment
//         </Badge>
//       );
//     if (status === "PAYMENT FAILED" || status === "FAILED")
//       return <Badge bg="danger">Failed</Badge>;
//     return <Badge bg="secondary">{status || "-"}</Badge>;
//   };

//   const getXenditStatusBadge = (status) => {
//     if (status === "PAID") return <Badge bg="success">Paid</Badge>;
//     if (status === "PENDING")
//       return (
//         <Badge bg="warning" text="dark">
//           Pending
//         </Badge>
//       );
//     return <Badge bg="secondary">{status || "-"}</Badge>;
//   };

//   const getOrderStatusIcon = (status) => {
//     if (status === 1)
//       return <MdCheckCircle size={20} color="green" title="Completed" />;
//     return <MdAccessTime size={20} color="orange" title="Pending" />;
//   };

//   const getCategoryBadge = (category) => {
//     if (category === "SERVICE") return <Badge bg="info">SERVICE</Badge>;
//     if (category === "APPOINTMENT")
//       return <Badge bg="primary">APPOINTMENT</Badge>;
//     return <Badge bg="secondary">{category}</Badge>;
//   };

//   const renderSortIcon = (field) => {
//     if (currentSortField !== field) return <FaSort className="text-muted" />;
//     return currentSortOrder === "ASC" ? <FaSortUp /> : <FaSortDown />;
//   };

//   // ─────────────────────────────────────────────────────────
//   // Kolom per tab
//   // ─────────────────────────────────────────────────────────
//   const appointmentColumns = [
//     {
//       key: "no",
//       header: "No",
//       width: "5%",
//       cell: (row, idx) => rowOffset + idx + 1,
//       sortField: null,
//       exportable: false,
//     },
//     {
//       key: "id",
//       header: "Order ID",
//       width: "15%",
//       cell: (row) => <span className="fw-semibold">{row.id}</span>,
//       sortField: "id",
//       exportValue: (row) => row.id,
//     },
//     {
//       key: "appointment_date",
//       header: "Tanggal",
//       width: "8%",
//       cell: (row) => formatDate(row.appointment_date),
//       sortField: "appointment_date",
//       exportValue: (row) => formatDate(row.appointment_date),
//     },
//     {
//       key: "appointment_time",
//       header: "Jam",
//       width: "8%",
//       cell: (row) => row.appointment_time || "-",
//       sortField: "appointment_time",
//       exportValue: (row) => row.appointment_time || "-",
//     },
//     {
//       key: "nama_unit_order",
//       header: "Unit",
//       width: "20%",
//       cell: (row) => row.nama_unit_order || "-",
//       sortField: "nama_unit_order",
//       exportValue: (row) => row.nama_unit_order || "-",
//     },
//     {
//       key: "no_booking",
//       header: "No. Booking",
//       width: "12%",
//       cell: (row) => row.no_booking || "-",
//       sortField: "no_booking",
//       exportValue: (row) => row.no_booking || "-",
//     },
//     {
//       key: "doctor_id",
//       header: "Dokter ID",
//       width: "8%",
//       cell: (row) => row.doctor_id || "-",
//       sortField: "doctor_id",
//       exportValue: (row) => row.doctor_id || "-",
//     },
//     {
//       key: "code_discount",
//       header: "Dokter ID",
//       width: "8%",
//       cell: (row) => row.code_discount || "-",
//       sortField: "code_discount",
//       exportValue: (row) => row.code_discount || "-",
//     },
//     {
//       key: "actions",
//       header: "Actions",
//       width: "20%",
//       cell: (row) => (
//         <div className="d-flex justify-content-center gap-2">
//           <Button
//             variant="outline-primary"
//             size="sm"
//             title="View Details"
//             onClick={() => onView(row)}
//           >
//             <IoEye />
//           </Button>
//           <Button
//             variant="outline-warning"
//             size="sm"
//             title="Edit"
//             onClick={() => onEdit(row)}
//           >
//             <IoCreate />
//           </Button>
//           <Button
//             variant="outline-danger"
//             size="sm"
//             title="Delete"
//             onClick={() => onDelete(row.id)}
//           >
//             <IoTrash />
//           </Button>
//         </div>
//       ),
//       sortField: null,
//       exportable: false,
//     },
//   ];

//   const serviceColumns = [
//     {
//       key: "no",
//       header: "No",
//       width: "5%",
//       cell: (row, idx) => rowOffset + idx + 1,
//       sortField: null,
//       exportable: false,
//     },
//     {
//       key: "id",
//       header: "Order ID",
//       width: "12%",
//       cell: (row) => <span className="fw-semibold">{row.id}</span>,
//       sortField: "id",
//       exportValue: (row) => row.id,
//     },
//     {
//       key: "category",
//       header: "Kategori",
//       width: "8%",
//       cell: (row) => getCategoryBadge(row.category),
//       sortField: "category",
//       exportValue: (row) => row.category || "-",
//     },
//     {
//       key: "payment_status",
//       header: "Status Payment",
//       width: "10%",
//       cell: (row) => getPaymentStatusBadge(row.payment_status),
//       sortField: "payment_status",
//       exportValue: (row) => row.payment_status || "-",
//     },
//     {
//       key: "order_status",
//       header: "Order Status",
//       width: "8%",
//       cell: (row) => (
//         <div className="text-center">
//           {getOrderStatusIcon(row.order_status)}
//         </div>
//       ),
//       sortField: "order_status",
//       exportValue: (row) => (row.order_status === 1 ? "Completed" : "Pending"),
//     },
//     {
//       key: "expiry_payment_date",
//       header: "Expiry Date",
//       width: "10%",
//       cell: (row) => formatDateTime(row.expiry_payment_date),
//       sortField: "expiry_payment_date",
//       exportValue: (row) => formatDateTime(row.expiry_payment_date),
//     },
//     {
//       key: "total_payment",
//       header: "Total",
//       width: "8%",
//       cell: (row) =>
//         row.total_payment
//           ? `Rp ${Number(row.total_payment).toLocaleString()}`
//           : "-",
//       sortField: "total_payment",
//       exportValue: (row) => (row.total_payment ? Number(row.total_payment) : 0),
//     },
//     {
//       key: "xendit_status",
//       header: "Xendit Status",
//       width: "8%",
//       cell: (row) => getXenditStatusBadge(row.xendit_status),
//       sortField: "xendit_status",
//       exportValue: (row) => row.xendit_status || "-",
//     },
//     {
//       key: "appointment_date",
//       header: "Tgl. Appointment",
//       width: "8%",
//       cell: (row) => formatDate(row.appointment_date),
//       sortField: "appointment_date",
//       exportValue: (row) => formatDate(row.appointment_date),
//     },
//     {
//       key: "nama_unit_order",
//       header: "Unit",
//       width: "15%",
//       cell: (row) => row.nama_unit_order || "-",
//       sortField: "nama_unit_order",
//       exportValue: (row) => row.nama_unit_order || "-",
//     },
//     {
//       key: "discount_name",
//       header: "discount name",
//       width: "15%",
//       cell: (row) => row.discount_name || "-",
//       sortField: "discount_name",
//       exportValue: (row) => row.discount_name || "-",
//     },
//     {
//       key: "actions",
//       header: "Actions",
//       width: "10%",
//       cell: (row) => (
//         <div className="d-flex justify-content-center gap-2">
//           <Button
//             variant="outline-primary"
//             size="sm"
//             title="View Details"
//             onClick={() => onView(row)}
//           >
//             <IoEye />
//           </Button>
//           <Button
//             variant="outline-warning"
//             size="sm"
//             title="Edit"
//             onClick={() => onEdit(row)}
//           >
//             <IoCreate />
//           </Button>
//           <Button
//             variant="outline-danger"
//             size="sm"
//             title="Delete"
//             onClick={() => onDelete(row.id)}
//           >
//             <IoTrash />
//           </Button>
//         </div>
//       ),
//       sortField: null,
//       exportable: false,
//     },
//   ];

//   const columns =
//     activeTab === "APPOINTMENT" ? appointmentColumns : serviceColumns;

//   const exportableColumns = useMemo(
//     () => columns.filter((c) => c.exportable !== false && c.exportValue),
//     [columns],
//   );

//   // ─────────────────────────────────────────────────────────
//   // Filter Kategori
//   // ─────────────────────────────────────────────────────────
//   const applyCategoryFilter = (data) => {
//     if (exportCategory === "ALL") return data;
//     return data.filter((row) => row.category === exportCategory);
//   };

//   // ─────────────────────────────────────────────────────────
//   // Filter Tanggal
//   // ─────────────────────────────────────────────────────────
//   const applyDateFilter = (data) => {
//     if (!exportDateFrom && !exportDateTo && exportIncludeFuture) {
//       return data;
//     }

//     const now = Date.now();
//     const fromTime = exportDateFrom
//       ? new Date(exportDateFrom).setHours(0, 0, 0, 0)
//       : null;
//     const toTime = exportDateTo
//       ? new Date(exportDateTo).setHours(23, 59, 59, 999)
//       : null;

//     return data.filter((row) => {
//       const raw = row[exportDateField];
//       if (!raw) return false;
//       const t = new Date(raw).getTime();

//       if (!exportIncludeFuture && t > now) return false;
//       if (fromTime !== null && t < fromTime) return false;
//       if (toTime !== null && t > toTime) return false;
//       return true;
//     });
//   };

//   // ─────────────────────────────────────────────────────────
//   // Sumber data untuk export
//   // ─────────────────────────────────────────────────────────
//   const getSourceData = () => {
//     const base = exportSource === "all" && allDataCache ? allDataCache : orders;
//     return applyCategoryFilter(base);
//   };

//   const exportPreviewCount = useMemo(() => {
//     try {
//       return applyDateFilter(getSourceData()).length;
//     } catch {
//       return 0;
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     orders,
//     allDataCache,
//     exportSource,
//     exportCategory,
//     exportDateFrom,
//     exportDateTo,
//     exportDateField,
//     exportIncludeFuture,
//   ]);

//   // ─────────────────────────────────────────────────────────
//   // Handlers Export
//   // ─────────────────────────────────────────────────────────
//   const handleOpenExportModal = () => {
//     setSelectedColumns(exportableColumns.map((c) => c.key));
//     setShowExportModal(true);
//   };

//   const handleToggleColumn = (key) => {
//     setSelectedColumns((prev) =>
//       prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
//     );
//   };

//   const handleSelectAllColumns = () =>
//     setSelectedColumns(exportableColumns.map((c) => c.key));

//   const handleDeselectAllColumns = () => setSelectedColumns([]);

//   const handleFetchAllData = async () => {
//     if (!onFetchAllForExport) return;
//     try {
//       setExporting(true);
//       const data = await onFetchAllForExport();
//       setAllDataCache(data || []);
//       setExportSource("all");
//     } catch (err) {
//       alert("Gagal mengambil semua data: " + err.message);
//     } finally {
//       setExporting(false);
//     }
//   };

//   const handleExportExcel = async () => {
//     try {
//       setExporting(true);

//       // 1) Ambil data sumber
//       let dataToExport;

//       if (exportSource === "all" && allDataCache) {
//         // sudah di-cache → pakai langsung
//         dataToExport = applyCategoryFilter(allDataCache);
//       } else if (exportSource === "all" && onFetchAllForExport) {
//         // belum di-fetch → fetch dulu
//         const data = await onFetchAllForExport();
//         setAllDataCache(data || []);
//         dataToExport = applyCategoryFilter(data || []);
//       } else {
//         dataToExport = getSourceData();
//       }

//       // 2) Filter tanggal
//       dataToExport = applyDateFilter(dataToExport);

//       if (dataToExport.length === 0) {
//         alert("Tidak ada data untuk di-export dengan filter saat ini.");
//         setExporting(false);
//         return;
//       }

//       // 3) Filter kolom
//       const colsToUse = exportableColumns.filter((c) =>
//         selectedColumns.includes(c.key),
//       );

//       if (colsToUse.length === 0) {
//         alert("Pilih minimal satu kolom untuk di-export.");
//         setExporting(false);
//         return;
//       }

//       // 4) Bangun rows
//       const excelRows = dataToExport.map((row, idx) => {
//         const obj = { No: idx + 1 };
//         colsToUse.forEach((col) => {
//           obj[col.header] = col.exportValue
//             ? col.exportValue(row)
//             : (row[col.key] ?? "-");
//         });
//         return obj;
//       });

//       // 5) Worksheet
//       const worksheet = XLSX.utils.json_to_sheet(excelRows);

//       const colWidths = Object.keys(excelRows[0] || {}).map((key) => ({
//         wch:
//           Math.max(
//             key.length,
//             ...excelRows.map((r) => String(r[key] ?? "").length),
//           ) + 2,
//       }));
//       worksheet["!cols"] = colWidths;

//       const workbook = XLSX.utils.book_new();

//       const sheetName =
//         exportCategory === "ALL"
//           ? "Semua"
//           : exportCategory === "SERVICE"
//             ? "Service"
//             : "Appointment";

//       XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

//       const dateSuffix =
//         exportDateFrom || exportDateTo
//           ? `_${exportDateFrom || "awal"}_sd_${exportDateTo || "akhir"}`
//           : `_${new Date().toISOString().slice(0, 10)}`;

//       const fileName = `Orders_${sheetName}${dateSuffix}.xlsx`;

//       // 7) Simpan
//       const excelBuffer = XLSX.write(workbook, {
//         bookType: "xlsx",
//         type: "array",
//       });
//       const blob = new Blob([excelBuffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       saveAs(blob, fileName);

//       setShowExportModal(false);
//     } catch (err) {
//       console.error("Export error:", err);
//       alert("Gagal export ke Excel: " + err.message);
//     } finally {
//       setExporting(false);
//     }
//   };
  
//   const renderHeader = () => (
//     <thead>
//       <tr>
//         {columns.map((col, idx) => (
//           <th key={idx} style={{ width: col.width }}>
//             {col.sortField ? (
//               <Button
//                 variant="link"
//                 className="p-0 text-decoration-none text-white fw-semibold"
//                 onClick={() => onSort(col.sortField)}
//               >
//                 {col.header} {renderSortIcon(col.sortField)}
//               </Button>
//             ) : (
//               <span className="fw-semibold">{col.header}</span>
//             )}
//           </th>
//         ))}
//       </tr>
//     </thead>
//   );

//   const renderBody = () => (
//     <tbody>
//       {filteredOrders.map((order, idx) => (
//         <tr key={order.id}>
//           {columns.map((col, colIdx) => (
//             <td key={colIdx}>{col.cell(order, idx)}</td>
//           ))}
//         </tr>
//       ))}
//     </tbody>
//   );

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" variant="primary" />
//         <p className="mt-2">Loading orders...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <Alert variant="danger" className="my-4">
//         <Alert.Heading>Error Loading Data</Alert.Heading>
//         <p>{error}</p>
//       </Alert>
//     );
//   }

//   return (
//     <>
//       {/* Tabs + Tombol Export */}
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
//         <Nav
//           variant="tabs"
//           activeKey={activeTab}
//           onSelect={(k) => setActiveTab(k)}
//           className="flex-grow-1 border-0"
//         >
//           <Nav.Item>
//             <Nav.Link eventKey="all">Semua ({counts.all})</Nav.Link>
//           </Nav.Item>
//           <Nav.Item>
//             <Nav.Link eventKey="SERVICE">SERVICE ({counts.SERVICE})</Nav.Link>
//           </Nav.Item>
//           <Nav.Item>
//             <Nav.Link eventKey="APPOINTMENT">
//               APPOINTMENT ({counts.APPOINTMENT})
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <Button
//           variant="success"
//           className="d-flex align-items-center gap-2"
//           onClick={handleOpenExportModal}
//           disabled={filteredOrders.length === 0 && !onFetchAllForExport}
//         >
//           <IoDownload /> Export Excel
//         </Button>
//       </div>

//       {/* Table / Empty */}
//       {filteredOrders.length === 0 ? (
//         <div className="text-center py-5 border rounded">
//           <p className="text-muted mb-2">No orders found</p>
//           {pagination.search && (
//             <small className="text-muted">
//               Try adjusting your search or filter
//             </small>
//           )}
//         </div>
//       ) : (
//         <div className="table-responsive">
//           <Table hover striped className="align-middle">
//             {renderHeader()}
//             {renderBody()}
//           </Table>
//         </div>
//       )}

//       {/* Modal Export */}
//       <Modal
//         show={showExportModal}
//         onHide={() => setShowExportModal(false)}
//         size="lg"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Export ke Excel</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Alert variant="info" className="py-2 mb-3">
//             Tab aktif: <b>{activeTab.toUpperCase()}</b> —{" "}
//             <b>{filteredOrders.length}</b> baris di halaman ini.
//             {allDataCache && (
//               <>
//                 {" "}
//                 | Total server: <b>{allDataCache.length}</b> baris
//               </>
//             )}
//           </Alert>

//           {/* Sumber Data */}
//           {onFetchAllForExport && (
//             <>
//               <h6 className="fw-bold mb-2">Sumber Data</h6>
//               <Form.Group className="mb-3">
//                 <Form.Check
//                   type="radio"
//                   id="src-current"
//                   name="exportSource"
//                   label={`Halaman aktif saja (${orders.length} baris)`}
//                   checked={exportSource === "current"}
//                   onChange={() => setExportSource("current")}
//                 />
//                 <Form.Check
//                   type="radio"
//                   id="src-all"
//                   name="exportSource"
//                   label={
//                     <>
//                       Semua data dari server{" "}
//                       {allDataCache ? (
//                         <Badge bg="success">
//                           {allDataCache.length} baris (sudah diambil)
//                         </Badge>
//                       ) : (
//                         <Badge bg="secondary">belum diambil</Badge>
//                       )}
//                     </>
//                   }
//                   checked={exportSource === "all"}
//                   onChange={() => setExportSource("all")}
//                 />
//               </Form.Group>
//               {exportSource === "all" && !allDataCache && (
//                 <Button
//                   size="sm"
//                   variant="outline-primary"
//                   className="mb-3"
//                   onClick={handleFetchAllData}
//                   disabled={exporting}
//                 >
//                   {exporting
//                     ? "Mengambil data..."
//                     : "Ambil Semua Data Sekarang"}
//                 </Button>
//               )}
//               {exportSource === "all" && allDataCache && (
//                 <div className="mb-3">
//                   <Badge bg="success" className="me-2">
//                     ✓ {allDataCache.length} baris siap di-export
//                   </Badge>
//                   <Button
//                     size="sm"
//                     variant="outline-secondary"
//                     onClick={() => {
//                       setAllDataCache(null);
//                       handleFetchAllData();
//                     }}
//                     disabled={exporting}
//                   >
//                     Refresh
//                   </Button>
//                 </div>
//               )}
//               <hr />
//             </>
//           )}

//           {/* Kategori */}
//           <h6 className="fw-bold mb-2">Kategori</h6>
//           <Form.Group className="mb-3">
//             <Form.Select
//               value={exportCategory}
//               onChange={(e) => setExportCategory(e.target.value)}
//             >
//               <option value="ALL">
//                 Semua Kategori ({allDataCache?.length ?? orders.length})
//               </option>
//               <option value="SERVICE">SERVICE ({counts.SERVICE})</option>
//               <option value="APPOINTMENT">
//                 APPOINTMENT ({counts.APPOINTMENT})
//               </option>
//             </Form.Select>
//             <Form.Text className="text-muted">
//               Pilih kategori order yang mau di-export.
//             </Form.Text>
//           </Form.Group>

//           <hr />

//           {/* Rentang Tanggal */}
//           <h6 className="fw-bold mb-2">Rentang Tanggal (opsional)</h6>
//           <Row className="g-3 mb-2">
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label className="small mb-1">Berdasarkan</Form.Label>
//                 <Form.Select
//                   value={exportDateField}
//                   onChange={(e) => setExportDateField(e.target.value)}
//                 >
//                   <option value="appointment_date">Tanggal Appointment</option>
//                   <option value="created_at">Tanggal Dibuat</option>
//                   <option value="expiry_payment_date">
//                     Expiry Payment Date
//                   </option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label className="small mb-1">Dari Tanggal</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={exportDateFrom}
//                   onChange={(e) => setExportDateFrom(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label className="small mb-1">Sampai Tanggal</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={exportDateTo}
//                   onChange={(e) => setExportDateTo(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Check
//             type="checkbox"
//             id="include-future"
//             className="mb-2"
//             label={
//               <>
//                 <b>Sertakan data dengan tanggal di masa depan</b>{" "}
//                 <small className="text-muted">
//                   (biarkan tercentang kalau ingin semua data)
//                 </small>
//               </>
//             }
//             checked={exportIncludeFuture}
//             onChange={(e) => setExportIncludeFuture(e.target.checked)}
//           />

//           {(exportDateFrom || exportDateTo) && (
//             <div className="mb-3">
//               <Button
//                 variant="outline-secondary"
//                 size="sm"
//                 onClick={() => {
//                   setExportDateFrom("");
//                   setExportDateTo("");
//                 }}
//               >
//                 Reset Tanggal
//               </Button>
//             </div>
//           )}

//           <Alert variant="light" className="py-2 small mb-3">
//             ℹ️ Kosongkan tanggal untuk mengexport <b>SEMUA data</b> tanpa
//             batasan — termasuk appointment yang akan datang.
//           </Alert>

//           <hr />

//           {/* Pilih Kolom */}
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <h6 className="fw-bold mb-0">
//               Pilih Kolom ({selectedColumns.length}/{exportableColumns.length})
//             </h6>
//             <ButtonGroup size="sm">
//               <Button
//                 variant="outline-primary"
//                 onClick={handleSelectAllColumns}
//               >
//                 Pilih Semua
//               </Button>
//               <Button
//                 variant="outline-secondary"
//                 onClick={handleDeselectAllColumns}
//               >
//                 Kosongkan
//               </Button>
//             </ButtonGroup>
//           </div>

//           <Row className="g-2">
//             {exportableColumns.map((col) => (
//               <Col md={4} sm={6} key={col.key}>
//                 <Form.Check
//                   type="checkbox"
//                   id={`col-${col.key}`}
//                   label={col.header}
//                   checked={selectedColumns.includes(col.key)}
//                   onChange={() => handleToggleColumn(col.key)}
//                 />
//               </Col>
//             ))}
//           </Row>
//         </Modal.Body>

//         <Modal.Footer className="d-flex justify-content-between">
//           <div className="text-muted small">
//             Akan mengexport <b>{exportPreviewCount}</b> baris ×{" "}
//             <b>{selectedColumns.length}</b> kolom
//           </div>
//           <div>
//             <Button
//               variant="secondary"
//               onClick={() => setShowExportModal(false)}
//               disabled={exporting}
//             >
//               Batal
//             </Button>
//             <Button
//               variant="success"
//               className="ms-2 d-inline-flex align-items-center gap-2"
//               onClick={handleExportExcel}
//               disabled={exporting || selectedColumns.length === 0}
//             >
//               {exporting ? (
//                 <>
//                   <Spinner animation="border" size="sm" /> Exporting...
//                 </>
//               ) : (
//                 <>
//                   <IoDownload /> Export Sekarang
//                 </>
//               )}
//             </Button>
//           </div>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default OrdersTable;
import React, { useState, useMemo } from "react";
import {
  Table,
  Badge,
  Button,
  Spinner,
  Alert,
  Modal,
  Form,
  Row,
  Col,
  ButtonGroup,
} from "react-bootstrap";
import { IoEye, IoCreate, IoTrash, IoDownload } from "react-icons/io5";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { MdAccessTime, MdCheckCircle } from "react-icons/md";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const OrdersTable = ({
  orders = [],
  loading = false,
  error = null,
  pagination = {},
  meta = {},
  currentSortField = null,
  currentSortOrder = "DESC",
  onSort = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onView = () => {},
  onFetchAllForExport = null,
}) => {
  // ─────────────────────────────────────────────────────────
  // 🎯 Offset pagination (biar nomor tabel tidak reset antar halaman)
  // ─────────────────────────────────────────────────────────
  const currentPage = Number(
    pagination?.page ?? pagination?.currentPage ?? meta?.page ?? 1,
  );
  const perPage = Number(
    pagination?.limit ??
      pagination?.perPage ??
      meta?.perPage ??
      meta?.limit ??
      (orders.length || 10),
  );
  const rowOffset = (currentPage - 1) * perPage;

  // ─────────────────────────────────────────────────────────
  // State Export
  // ─────────────────────────────────────────────────────────
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportCategory, setExportCategory] = useState("ALL");
  const [exportDateField, setExportDateField] = useState("appointment_date");
  const [exportDateFrom, setExportDateFrom] = useState("");
  const [exportDateTo, setExportDateTo] = useState("");
  const [exportIncludeFuture, setExportIncludeFuture] = useState(true);
  const [exportSource, setExportSource] = useState("current"); // 'current' | 'all'
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [allDataCache, setAllDataCache] = useState(null);

  // ─────────────────────────────────────────────────────────
  // Counts per kategori
  // (pakai allDataCache kalau ada, biar akurat total server)
  // ─────────────────────────────────────────────────────────
  const counts = useMemo(() => {
    const source =
      allDataCache && allDataCache.length > 0 ? allDataCache : orders;
    return {
      all: source.length,
      SERVICE: source.filter((o) => o.category === "SERVICE").length,
      APPOINTMENT: source.filter((o) => o.category === "APPOINTMENT").length,
    };
  }, [orders, allDataCache]);

  // ─────────────────────────────────────────────────────────
  // Format helpers
  // ─────────────────────────────────────────────────────────
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ─────────────────────────────────────────────────────────
  // Badge renderers
  // ─────────────────────────────────────────────────────────
  const getPaymentStatusBadge = (status) => {
    if (status === "PAYMENT SUCCESS" || status === "PAID")
      return <Badge bg="success">Success</Badge>;
    if (status === "NEED PAYMENT")
      return (
        <Badge bg="warning" text="dark">
          Need Payment
        </Badge>
      );
    if (status === "PAYMENT FAILED" || status === "FAILED")
      return <Badge bg="danger">Failed</Badge>;
    return <Badge bg="secondary">{status || "-"}</Badge>;
  };

  const getXenditStatusBadge = (status) => {
    if (status === "PAID") return <Badge bg="success">Paid</Badge>;
    if (status === "PENDING")
      return (
        <Badge bg="warning" text="dark">
          Pending
        </Badge>
      );
    return <Badge bg="secondary">{status || "-"}</Badge>;
  };

  const getOrderStatusIcon = (status) => {
    if (status === 1)
      return <MdCheckCircle size={20} color="green" title="Completed" />;
    return <MdAccessTime size={20} color="orange" title="Pending" />;
  };

  const getCategoryBadge = (category) => {
    if (category === "SERVICE") return <Badge bg="info">SERVICE</Badge>;
    if (category === "APPOINTMENT")
      return <Badge bg="primary">APPOINTMENT</Badge>;
    return <Badge bg="secondary">{category}</Badge>;
  };

  const renderSortIcon = (field) => {
    if (currentSortField !== field) return <FaSort className="text-muted" />;
    return currentSortOrder === "ASC" ? <FaSortUp /> : <FaSortDown />;
  };

  // ─────────────────────────────────────────────────────────
  // Kolom gabungan (SERVICE + APPOINTMENT) — ditampilkan untuk semua data
  // ─────────────────────────────────────────────────────────
  const columns = [
    {
      key: "no",
      header: "No",
      width: "4%",
      cell: (row, idx) => rowOffset + idx + 1,
      sortField: null,
      exportable: false,
    },
    {
      key: "id",
      header: "Order ID",
      width: "10%",
      cell: (row) => <span className="fw-semibold">{row.id}</span>,
      sortField: "id",
      exportValue: (row) => row.id,
    },
    {
      key: "category",
      header: "Kategori",
      width: "8%",
      cell: (row) => getCategoryBadge(row.category),
      sortField: "category",
      exportValue: (row) => row.category || "-",
    },
    {
      key: "payment_status",
      header: "Status Payment",
      width: "9%",
      cell: (row) => getPaymentStatusBadge(row.payment_status),
      sortField: "payment_status",
      exportValue: (row) => row.payment_status || "-",
    },
    {
      key: "order_status",
      header: "Order Status",
      width: "6%",
      cell: (row) => (
        <div className="text-center">
          {getOrderStatusIcon(row.order_status)}
        </div>
      ),
      sortField: "order_status",
      exportValue: (row) => (row.order_status === 1 ? "Completed" : "Pending"),
    },
    {
      key: "xendit_status",
      header: "Xendit Status",
      width: "7%",
      cell: (row) => getXenditStatusBadge(row.xendit_status),
      sortField: "xendit_status",
      exportValue: (row) => row.xendit_status || "-",
    },
    {
      key: "total_payment",
      header: "Total",
      width: "8%",
      cell: (row) =>
        row.total_payment
          ? `Rp ${Number(row.total_payment).toLocaleString()}`
          : "-",
      sortField: "total_payment",
      exportValue: (row) => (row.total_payment ? Number(row.total_payment) : 0),
    },
    {
      key: "expiry_payment_date",
      header: "Expiry Date",
      width: "10%",
      cell: (row) => formatDateTime(row.expiry_payment_date),
      sortField: "expiry_payment_date",
      exportValue: (row) => formatDateTime(row.expiry_payment_date),
    },
    {
      key: "appointment_date",
      header: "Tgl. Appointment",
      width: "8%",
      cell: (row) => formatDate(row.appointment_date),
      sortField: "appointment_date",
      exportValue: (row) => formatDate(row.appointment_date),
    },
    {
      key: "appointment_time",
      header: "Jam",
      width: "6%",
      cell: (row) => row.appointment_time || "-",
      sortField: "appointment_time",
      exportValue: (row) => row.appointment_time || "-",
    },
    {
      key: "nama_unit_order",
      header: "Unit",
      width: "14%",
      cell: (row) => row.nama_unit_order || "-",
      sortField: "nama_unit_order",
      exportValue: (row) => row.nama_unit_order || "-",
    },
    {
      key: "no_booking",
      header: "No. Booking",
      width: "10%",
      cell: (row) => row.no_booking || "-",
      sortField: "no_booking",
      exportValue: (row) => row.no_booking || "-",
    },
    {
      key: "doctor_id",
      header: "Dokter ID",
      width: "7%",
      cell: (row) => row.doctor_id || "-",
      sortField: "doctor_id",
      exportValue: (row) => row.doctor_id || "-",
    },
    {
      key: "discount_name",
      header: "Discount Name",
      width: "10%",
      cell: (row) => row.discount_name || "-",
      sortField: "discount_name",
      exportValue: (row) => row.discount_name || "-",
    },
    {
      key: "code_discount",
      header: "Code Discount",
      width: "8%",
      cell: (row) => row.code_discount || "-",
      sortField: "code_discount",
      exportValue: (row) => row.code_discount || "-",
    },
    {
      key: "actions",
      header: "Actions",
      width: "10%",
      cell: (row) => (
        <div className="d-flex justify-content-center gap-2">
          <Button
            variant="outline-primary"
            size="sm"
            title="View Details"
            onClick={() => onView(row)}
          >
            <IoEye />
          </Button>
          <Button
            variant="outline-warning"
            size="sm"
            title="Edit"
            onClick={() => onEdit(row)}
          >
            <IoCreate />
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            title="Delete"
            onClick={() => onDelete(row.id)}
          >
            <IoTrash />
          </Button>
        </div>
      ),
      sortField: null,
      exportable: false,
    },
  ];

  const exportableColumns = useMemo(
    () => columns.filter((c) => c.exportable !== false && c.exportValue),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columns],
  );

  // ─────────────────────────────────────────────────────────
  // Filter Kategori
  // ─────────────────────────────────────────────────────────
  const applyCategoryFilter = (data) => {
    if (exportCategory === "ALL") return data;
    return data.filter((row) => row.category === exportCategory);
  };

  // ─────────────────────────────────────────────────────────
  // Filter Tanggal
  // ─────────────────────────────────────────────────────────
  const applyDateFilter = (data) => {
    if (!exportDateFrom && !exportDateTo && exportIncludeFuture) {
      return data;
    }

    const now = Date.now();
    const fromTime = exportDateFrom
      ? new Date(exportDateFrom).setHours(0, 0, 0, 0)
      : null;
    const toTime = exportDateTo
      ? new Date(exportDateTo).setHours(23, 59, 59, 999)
      : null;

    return data.filter((row) => {
      const raw = row[exportDateField];
      if (!raw) return false;
      const t = new Date(raw).getTime();

      if (!exportIncludeFuture && t > now) return false;
      if (fromTime !== null && t < fromTime) return false;
      if (toTime !== null && t > toTime) return false;
      return true;
    });
  };

  // ─────────────────────────────────────────────────────────
  // Sumber data untuk export
  // ─────────────────────────────────────────────────────────
  const getSourceData = () => {
    const base = exportSource === "all" && allDataCache ? allDataCache : orders;
    return applyCategoryFilter(base);
  };

  const exportPreviewCount = useMemo(() => {
    try {
      return applyDateFilter(getSourceData()).length;
    } catch {
      return 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    orders,
    allDataCache,
    exportSource,
    exportCategory,
    exportDateFrom,
    exportDateTo,
    exportDateField,
    exportIncludeFuture,
  ]);

  // ─────────────────────────────────────────────────────────
  // Handlers Export
  // ─────────────────────────────────────────────────────────
  const handleOpenExportModal = () => {
    setSelectedColumns(exportableColumns.map((c) => c.key));
    setShowExportModal(true);
  };

  const handleToggleColumn = (key) => {
    setSelectedColumns((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const handleSelectAllColumns = () =>
    setSelectedColumns(exportableColumns.map((c) => c.key));

  const handleDeselectAllColumns = () => setSelectedColumns([]);

  const handleFetchAllData = async () => {
    if (!onFetchAllForExport) return;
    try {
      setExporting(true);
      const data = await onFetchAllForExport();
      setAllDataCache(data || []);
      setExportSource("all");
    } catch (err) {
      alert("Gagal mengambil semua data: " + err.message);
    } finally {
      setExporting(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);

      // 1) Ambil data sumber
      let dataToExport;

      if (exportSource === "all" && allDataCache) {
        dataToExport = applyCategoryFilter(allDataCache);
      } else if (exportSource === "all" && onFetchAllForExport) {
        const data = await onFetchAllForExport();
        setAllDataCache(data || []);
        dataToExport = applyCategoryFilter(data || []);
      } else {
        dataToExport = getSourceData();
      }

      // 2) Filter tanggal
      dataToExport = applyDateFilter(dataToExport);

      if (dataToExport.length === 0) {
        alert("Tidak ada data untuk di-export dengan filter saat ini.");
        setExporting(false);
        return;
      }

      // 3) Filter kolom
      const colsToUse = exportableColumns.filter((c) =>
        selectedColumns.includes(c.key),
      );

      if (colsToUse.length === 0) {
        alert("Pilih minimal satu kolom untuk di-export.");
        setExporting(false);
        return;
      }

      // 4) Bangun rows
      const excelRows = dataToExport.map((row, idx) => {
        const obj = { No: idx + 1 };
        colsToUse.forEach((col) => {
          obj[col.header] = col.exportValue
            ? col.exportValue(row)
            : (row[col.key] ?? "-");
        });
        return obj;
      });

      // 5) Worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelRows);

      const colWidths = Object.keys(excelRows[0] || {}).map((key) => ({
        wch:
          Math.max(
            key.length,
            ...excelRows.map((r) => String(r[key] ?? "").length),
          ) + 2,
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();

      const sheetName =
        exportCategory === "ALL"
          ? "Semua"
          : exportCategory === "SERVICE"
            ? "Service"
            : "Appointment";

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      const dateSuffix =
        exportDateFrom || exportDateTo
          ? `_${exportDateFrom || "awal"}_sd_${exportDateTo || "akhir"}`
          : `_${new Date().toISOString().slice(0, 10)}`;

      const fileName = `Orders_${sheetName}${dateSuffix}.xlsx`;

      // 7) Simpan
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);

      setShowExportModal(false);
    } catch (err) {
      console.error("Export error:", err);
      alert("Gagal export ke Excel: " + err.message);
    } finally {
      setExporting(false);
    }
  };

  const renderHeader = () => (
    <thead>
      <tr>
        {columns.map((col, idx) => (
          <th key={idx} style={{ width: col.width }}>
            {col.sortField ? (
              <Button
                variant="link"
                className="p-0 text-decoration-none text-white fw-semibold"
                onClick={() => onSort(col.sortField)}
              >
                {col.header} {renderSortIcon(col.sortField)}
              </Button>
            ) : (
              <span className="fw-semibold">{col.header}</span>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );

  const renderBody = () => (
    <tbody>
      {orders.map((order, idx) => (
        <tr key={order.id}>
          {columns.map((col, colIdx) => (
            <td key={colIdx}>{col.cell(order, idx)}</td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading orders...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="my-4">
        <Alert.Heading>Error Loading Data</Alert.Heading>
        <p>{error}</p>
      </Alert>
    );
  }

  return (
    <>
      {/* Header: Info + Tombol Export */}
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="fw-semibold">Semua Orders</span>
          <Badge bg="secondary">Total: {counts.all}</Badge>
          <Badge bg="info">SERVICE: {counts.SERVICE}</Badge>
          <Badge bg="primary">APPOINTMENT: {counts.APPOINTMENT}</Badge>
        </div>

        <Button
          variant="success"
          className="d-flex align-items-center gap-2"
          onClick={handleOpenExportModal}
          disabled={orders.length === 0 && !onFetchAllForExport}
        >
          <IoDownload /> Export Excel
        </Button>
      </div>

      {/* Table / Empty */}
      {orders.length === 0 ? (
        <div className="text-center py-5 border rounded">
          <p className="text-muted mb-2">No orders found</p>
          {pagination.search && (
            <small className="text-muted">
              Try adjusting your search or filter
            </small>
          )}
        </div>
      ) : (
        <div className="table-responsive">
          <Table hover striped className="align-middle">
            {renderHeader()}
            {renderBody()}
          </Table>
        </div>
      )}

      {/* Modal Export */}
      <Modal
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Export ke Excel</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Alert variant="info" className="py-2 mb-3">
            Total baris di halaman ini: <b>{orders.length}</b>
            {allDataCache && (
              <>
                {" "}
                | Total server: <b>{allDataCache.length}</b> baris
              </>
            )}
          </Alert>

          {/* Sumber Data */}
          {onFetchAllForExport && (
            <>
              <h6 className="fw-bold mb-2">Sumber Data</h6>
              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  id="src-current"
                  name="exportSource"
                  label={`Halaman aktif saja (${orders.length} baris)`}
                  checked={exportSource === "current"}
                  onChange={() => setExportSource("current")}
                />
                <Form.Check
                  type="radio"
                  id="src-all"
                  name="exportSource"
                  label={
                    <>
                      Semua data dari server{" "}
                      {allDataCache ? (
                        <Badge bg="success">
                          {allDataCache.length} baris (sudah diambil)
                        </Badge>
                      ) : (
                        <Badge bg="secondary">belum diambil</Badge>
                      )}
                    </>
                  }
                  checked={exportSource === "all"}
                  onChange={() => setExportSource("all")}
                />
              </Form.Group>
              {exportSource === "all" && !allDataCache && (
                <Button
                  size="sm"
                  variant="outline-primary"
                  className="mb-3"
                  onClick={handleFetchAllData}
                  disabled={exporting}
                >
                  {exporting
                    ? "Mengambil data..."
                    : "Ambil Semua Data Sekarang"}
                </Button>
              )}
              {exportSource === "all" && allDataCache && (
                <div className="mb-3">
                  <Badge bg="success" className="me-2">
                    ✓ {allDataCache.length} baris siap di-export
                  </Badge>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      setAllDataCache(null);
                      handleFetchAllData();
                    }}
                    disabled={exporting}
                  >
                    Refresh
                  </Button>
                </div>
              )}
              <hr />
            </>
          )}

          {/* Kategori */}
          <h6 className="fw-bold mb-2">Kategori</h6>
          <Form.Group className="mb-3">
            <Form.Select
              value={exportCategory}
              onChange={(e) => setExportCategory(e.target.value)}
            >
              <option value="ALL">
                Semua Kategori ({allDataCache?.length ?? orders.length})
              </option>
              <option value="SERVICE">SERVICE ({counts.SERVICE})</option>
              <option value="APPOINTMENT">
                APPOINTMENT ({counts.APPOINTMENT})
              </option>
            </Form.Select>
            <Form.Text className="text-muted">
              Pilih kategori order yang mau di-export.
            </Form.Text>
          </Form.Group>

          <hr />

          {/* Rentang Tanggal */}
          <h6 className="fw-bold mb-2">Rentang Tanggal (opsional)</h6>
          <Row className="g-3 mb-2">
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Berdasarkan</Form.Label>
                <Form.Select
                  value={exportDateField}
                  onChange={(e) => setExportDateField(e.target.value)}
                >
                  <option value="appointment_date">Tanggal Appointment</option>
                  <option value="created_at">Tanggal Dibuat</option>
                  <option value="expiry_payment_date">
                    Expiry Payment Date
                  </option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Dari Tanggal</Form.Label>
                <Form.Control
                  type="date"
                  value={exportDateFrom}
                  onChange={(e) => setExportDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Sampai Tanggal</Form.Label>
                <Form.Control
                  type="date"
                  value={exportDateTo}
                  onChange={(e) => setExportDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Check
            type="checkbox"
            id="include-future"
            className="mb-2"
            label={
              <>
                <b>Sertakan data dengan tanggal di masa depan</b>{" "}
                <small className="text-muted">
                  (biarkan tercentang kalau ingin semua data)
                </small>
              </>
            }
            checked={exportIncludeFuture}
            onChange={(e) => setExportIncludeFuture(e.target.checked)}
          />

          {(exportDateFrom || exportDateTo) && (
            <div className="mb-3">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  setExportDateFrom("");
                  setExportDateTo("");
                }}
              >
                Reset Tanggal
              </Button>
            </div>
          )}

          <Alert variant="light" className="py-2 small mb-3">
            ℹ️ Kosongkan tanggal untuk mengexport <b>SEMUA data</b> tanpa
            batasan — termasuk appointment yang akan datang.
          </Alert>

          <hr />

          {/* Pilih Kolom */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold mb-0">
              Pilih Kolom ({selectedColumns.length}/{exportableColumns.length})
            </h6>
            <ButtonGroup size="sm">
              <Button
                variant="outline-primary"
                onClick={handleSelectAllColumns}
              >
                Pilih Semua
              </Button>
              <Button
                variant="outline-secondary"
                onClick={handleDeselectAllColumns}
              >
                Kosongkan
              </Button>
            </ButtonGroup>
          </div>

          <Row className="g-2">
            {exportableColumns.map((col) => (
              <Col md={4} sm={6} key={col.key}>
                <Form.Check
                  type="checkbox"
                  id={`col-${col.key}`}
                  label={col.header}
                  checked={selectedColumns.includes(col.key)}
                  onChange={() => handleToggleColumn(col.key)}
                />
              </Col>
            ))}
          </Row>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between">
          <div className="text-muted small">
            Akan mengexport <b>{exportPreviewCount}</b> baris ×{" "}
            <b>{selectedColumns.length}</b> kolom
          </div>
          <div>
            <Button
              variant="secondary"
              onClick={() => setShowExportModal(false)}
              disabled={exporting}
            >
              Batal
            </Button>
            <Button
              variant="success"
              className="ms-2 d-inline-flex align-items-center gap-2"
              onClick={handleExportExcel}
              disabled={exporting || selectedColumns.length === 0}
            >
              {exporting ? (
                <>
                  <Spinner animation="border" size="sm" /> Exporting...
                </>
              ) : (
                <>
                  <IoDownload /> Export Sekarang
                </>
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrdersTable;